import { Font, Icon, Tooltip } from "pepsico-ds";
import React from "react";
const MAX_LENGTH = 25;
interface ArchieveListItemProps {
  chatId: string;
  sessionName: string;
  updatedDate: string;
  isActive?: boolean;
  primaryAction?: () => void;
  more?: React.ReactNode;
}
function ChatListItem(props: ArchieveListItemProps) {
  const {
    sessionName,
    updatedDate,
    isActive = false,
    primaryAction,
    more,
  } = props;

  const truncatedSessionName =
    sessionName.length > MAX_LENGTH
      ? sessionName.slice(0, MAX_LENGTH) + "..."
      : sessionName;

  const formattedDate = updatedDate
    ? `${new Date(updatedDate).toLocaleDateString()}, ${new Date(
        updatedDate
      ).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })}`
    : null;

  return (
    <div
      className={`chatItem ${isActive ? "active" : ""}`}
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "8px 0",
      }}
      onClick={primaryAction}
    >
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Icon
            alt="chat-icon"
            className="$color-icon-default"
            icon="chat"
            size="small"
            style={{ marginRight: "12px", marginLeft: "8px" }}
          />
          <Tooltip
            direction="bottom-middle"
            text={sessionName}
            maxWidth="200px"
            style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
          >
            <Font>{truncatedSessionName}</Font>
          </Tooltip>
        </div>
        <Font style={{ marginLeft: "8px" }} size={"xsmall"}>
          {formattedDate}
        </Font>
      </div>

      {more ? more : null}
    </div>
  );
}

export default ChatListItem;
